var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:{
    backLink: true,
    'backLink--left': _vm.direction === 'left',
    'backLink--right': _vm.direction === 'right',
  },on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }